import React from 'react';

const NotFoundPage = () => <h2>The requested page was not found</h2>;

export default NotFoundPage;
